import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  kpiObjectiveId: string;
  id: string;
};

const request = ({ kpiObjectiveId, id }: RequestDataType) => {
  return new ApiClient()
    .delete<ResponseMessageType>(
      `/api/members/kpi/kpi_objectives/${kpiObjectiveId}/kpi_daily_performances/${id}`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersKpiKpiObjectivesKpiDailyPerformancesDestroy = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
